import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutExciseTaxHistoryReport extends Layout {
    checkboxPageBreakAfterCustomer: Checkbox;
    checkboxPageBreakAfterProvince: Checkbox;
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxProvince: ExcludableTextbox;
    excludabletextboxTaxCode: ExcludableTextbox;
    sourceExciseTaxHistory: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxGroupBy: Textbox;
}
